import { motion } from 'framer-motion'
import { useT } from '../../lib/i18n'
import useReducedMotion from '../../hooks/useReducedMotion'

const ease = [0.22, 1, 0.36, 1]

export default function HeroQuote() {
  const t = useT()
  const reduced = useReducedMotion()

  return (
    <motion.figure
      className="relative max-w-3xl mx-auto text-center"
      initial={reduced ? false : { opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.72, ease }}
    >
      <blockquote className="font-display text-2xl md:text-3xl lg:text-4xl leading-snug text-white">
        <span aria-hidden="true" className="font-script text-5xl md:text-6xl text-white/40 leading-none mr-1">“</span>
        {t('hero.quote')}
        <span aria-hidden="true" className="font-script text-5xl md:text-6xl text-white/40 leading-none ml-1">”</span>
      </blockquote>
      <motion.figcaption
        className="mt-8 text-sm md:text-base font-semibold uppercase tracking-[0.25em] text-[var(--color-ink-muted)]"
        initial={reduced ? false : { opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4, ease }}
      >
        {t('hero.attribution')}
      </motion.figcaption>
    </motion.figure>
  )
}
